import Address from 'ipaddr.js';

export function compareCidr(a: string, b: string): number {
  const ipA = parseIpOrCidr(a).toByteArray();
  const ipB = parseIpOrCidr(b).toByteArray();
  const lenDiff = ipA.length - ipB.length;
  if (lenDiff != 0) return lenDiff;

  for (let i = 0; i < ipA.length; i++) {
    const diff = ipA[i] - ipB[i];
    if (diff != 0) return diff;
  }
}

function parseIpOrCidr(ipOrCidr: string): Address.IPv4 | Address.IPv6 {
  const pos = ipOrCidr.indexOf('/');
  return Address.parse(pos != -1 ? ipOrCidr.substring(0, pos) : ipOrCidr);
}
